// This function allow to reference chunks
__webpack_require__.miniCssF = function(chunkId) {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "static/" + chunkId + "." + chunkId + "." + {"1172": "6f4bf595c968","1716": "360cbd8d7a75","5336": "5083bc5218c4","6863": "454c9f289029","8357": "dd422574e14d",}[chunkId] + ".css"
}